/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { compose } from 'recompose';
import Media from 'react-media';
import { useSelector } from 'react-redux';
import MobileRegularUser from './MobileGiftList/Layouts/MobileRegularUser';
import DesktopRegularUser from './DesktopGiftList/Layouts/DesktopRegularUser';
import withPageView from '../../../../helpers/tracking/hocs/withPageView';
import CUSTOM_BREAKPOINTS from '../../style/customBreakpoints';
import { getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const RegularUser = () => {
    const breakpointExpr =  `(max-width: ${CUSTOM_BREAKPOINTS.tabLandscape}px)`;
    const featureFlags =  useSelector(getFeatureFlags);
    return (
        <>
            <Media query={breakpointExpr}>
                {(matches) => (       // eslint-disable-line arrow-parens
                    matches ? (
                        <>
                            <MobileRegularUser featureFlags={featureFlags}  />
                        </>
                    ) : (
                        <>
                            <DesktopRegularUser featureFlags={featureFlags} />
                        </>
                    )
                )}
            </Media>
        </>
    );
};

const enhance = compose(
    withPageView({
        pageViewSuccessTest: () => true,
    }),
);

export default enhance(RegularUser);
